<template>
  <div>
    <swiper :type="5"></swiper>
    <join></join>
  </div>
</template>

<script>
import swiper from "./swiper";
import join from "./agent/join";

export default {
  components: {
    swiper,
    join
  }
};
</script>